import { AxiosResponse } from "axios";
import { IMemberStatementSearchResult } from "../types/IMemberStatementSearchResult";
import { IStoragePath } from "../types/IMemberStatementSearchResult";
import axiosInstance from "../../setupAxios";

export class StorageRequests {
    public static async getStatementFiles(statements: IMemberStatementSearchResult[]): Promise<IMemberStatementSearchResult[]> {
        return new Promise<IMemberStatementSearchResult[]>((resolve, reject) => {
            Promise.all(statements.map(setDownloadProperties))
            .then((response: IMemberStatementSearchResult[]) => {
                resolve(response);
            })
            .catch (response => {
                reject(response);
            })
        });
    }
}

const setDownloadProperties = async (
  statement: IMemberStatementSearchResult
): Promise<IMemberStatementSearchResult> => {

  statement.downloadLink = [];
  statement.downloadName = [];

  try {
    const [crdResponse, csvResponse, pdfResponse] = await Promise.all([
      axiosInstance.post("Storage/PortalStatements", {
        Path: `payments/statements/PaymentRun-${statement.paymentRunCode}/crd`,
        IsRepertoireModule: false
      }),
      axiosInstance.post("Storage/PortalStatements", {
        Path: `payments/statements/PaymentRun-${statement.paymentRunCode}/csv`,
        IsRepertoireModule: false
      }),
      axiosInstance.post("Storage/PortalStatements", {
        Path: `payments/statements/PaymentRun-${statement.paymentRunCode}/pdf`,
        IsRepertoireModule: false
      })
    ]);


    const addFiles = (res: AxiosResponse<IStoragePath[]>) => {
      res.data.forEach(file => {
        if (file.name && file.name !== "") {
          statement.downloadLink!.push(file.fullName);
          statement.downloadName!.push(file.name);
        }
      });
    };

    addFiles(crdResponse);
    addFiles(csvResponse);
    addFiles(pdfResponse);

    return statement;

  } catch (err) {
    console.log(err);
  }
};



